// helper to fetch all items from an api endpoint
export async function fetchApiAllItems<TItem>(
  fetchItems: (
    page: number
  ) => Promise<{ items: TItem[]; hasNextPage: boolean }>,
  page = 1,
  prevs: TItem[] = []
): Promise<TItem[]> {
  const { items, hasNextPage } = await fetchItems(page);

  const newItems = prevs.concat(items);

  if (!hasNextPage) return newItems;

  const nextPage = page + 1;
  return await fetchApiAllItems(fetchItems, nextPage, newItems);
}
